import { saldoRetidoConfig as config } from "../../config/niches/saldoRetido";
import { usePageMeta } from "../../hooks/usePageMeta";
import { NicheTopBar } from "../../components/niche/NicheTopBar";
import { NicheHero } from "../../components/niche/NicheHero";
import { SaldoRetidoFlow } from "../../components/niche/SaldoRetidoFlow";
import { LegalInfo } from "../../components/niche/LegalInfo";
import { Footer } from "../../components/shared/Footer";
import { NicheGuides } from "../../components/niche/NicheGuides";
import { IndependenceBanner } from "../../components/shared/IndependenceBanner";
import content from "../../data/content.json";

const { blocks: BLOCKS, notice: NOTICE } = content.legal["saldo-retido"];

export default function SaldoRetidoPage() {
  usePageMeta(config.metaTitle, config.metaDescription);
  return (
    <div className="flex min-h-screen flex-col">
      <IndependenceBanner />
      <NicheTopBar badge={config.badge} />
      <main data-testid="saldo-retido-page" className="flex-1">
        <NicheHero config={config} />
        <SaldoRetidoFlow config={config} />
        <LegalInfo blocks={BLOCKS} notice={NOTICE} />
        <NicheGuides niche="saldo-retido" />
      </main>
      <Footer />
    </div>
  );
}
